
import { Component, Prop, Vue} from "vue-property-decorator";
import { ToastOptions } from "@/models";

@Component
export default class McToast extends Vue {
    @Prop({default: ""}) readonly id!: string;
    @Prop({default: ""}) readonly toastOptions!: ToastOptions;
    
}
